import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { ItemSelectorState, ItemSelectorStore, SimpleActionCreator } from '../../helpers/types';

@Component({
  selector: 'app-item-selector',
  templateUrl: './item-selector.component.html'
})
export class ItemSelectorComponent {
  @Input() action: SimpleActionCreator<any>;
  @Input() field: string;
  @Input() id: string;
  @Input() state: Observable<ItemSelectorState>;

  constructor(private store: Store<ItemSelectorStore>) {}

  switchSelection(): void {
    this.store.dispatch(this.action({ id: this.id }));
  }
}
